document.documentElement.classList.remove("no-js");

const money = (cents) => {
  const currency = window.Shopify?.currency?.active || "USD";
  return new Intl.NumberFormat(document.documentElement.lang || "en", {
    style: "currency",
    currency,
  }).format(cents / 100);
};

function initializeSeamlessMarquees(root = document) {
  root.querySelectorAll("[data-seamless-marquee]").forEach((track) => {
    const group = track.querySelector("[data-marquee-group]");
    const copy = track.querySelector("[data-marquee-copy]");
    const viewport = track.parentElement;
    if (!group || !copy || !viewport || group.dataset.marqueeReady === "true") return;

    const originalItems = [...group.children].map((item) => item.cloneNode(true));
    if (!originalItems.length) return;

    while (group.scrollWidth < viewport.clientWidth * 1.15) {
      originalItems.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.removeAttribute("data-block-id");
        group.appendChild(clone);
      });
    }

    copy.replaceChildren(...[...group.children].map((item) => {
      const clone = item.cloneNode(true);
      clone.removeAttribute("data-block-id");
      return clone;
    }));
    group.dataset.marqueeReady = "true";
  });
}

initializeSeamlessMarquees();

function submitCartForm(form, action) {
  if (!form || form.dataset.submitting === "true") return;
  form.dataset.submitting = "true";
  form.querySelectorAll("[data-cart-action]").forEach((control) => {
    control.disabled = true;
  });
  form.querySelectorAll("[data-cart-quantity]").forEach((control) => {
    control.readOnly = true;
  });

  const actionInput = document.createElement("input");
  actionInput.type = "hidden";
  actionInput.name = action;
  actionInput.value = action === "checkout" ? "Checkout" : "Update cart";
  form.appendChild(actionInput);
  form.submit();
}

let cartUpdateTimer;

document.addEventListener("click", (event) => {
  const optionButton = event.target.closest("[data-option-value]");
  if (!optionButton) return;

  const group = optionButton.closest("[data-option-position]");
  group?.querySelector(".is-selected")?.classList.remove("is-selected");
  optionButton.classList.add("is-selected");
  group?.querySelectorAll("[aria-pressed]").forEach((button) => {
    button.setAttribute("aria-pressed", String(button === optionButton));
  });
  const label = group?.querySelector("[data-selected-option]");
  if (label) label.textContent = optionButton.dataset.optionValue;
  const section = optionButton.closest("[data-product-section]");
  window.setTimeout(() => {
    try {
      updateSasSelectedVariant(section);
      if (section) delete section.dataset.variantError;
    } catch (error) {
      if (section) section.dataset.variantError = `${error.name}: ${error.message}`;
    }
  }, 0);
}, true);

document.addEventListener("click", (event) => {
  const liveMenuButton = event.target.closest(".live-header__menu-button");
  if (liveMenuButton) {
    const menu = document.querySelector("#MobileMenu");
    const shouldOpen = menu?.hidden;
    if (menu) menu.hidden = !shouldOpen;
    liveMenuButton.setAttribute("aria-expanded", String(Boolean(shouldOpen)));
    document.body.classList.toggle("mobile-menu-open", Boolean(shouldOpen));
  }

  const menuButton = event.target.closest(".menu-toggle");
  if (menuButton) {
    const menu = document.querySelector(".main-nav");
    const isOpen = menu?.classList.toggle("is-open");
    menuButton.setAttribute("aria-expanded", String(Boolean(isOpen)));
  }

  const filterButton = event.target.closest("[data-filter-toggle]");
  if (filterButton) {
    const drawer = document.querySelector("[data-filter-drawer]");
    const shouldOpen = drawer?.hidden;
    if (drawer) drawer.hidden = !shouldOpen;
    filterButton.setAttribute("aria-expanded", String(Boolean(shouldOpen)));
    const symbol = filterButton.querySelector("span");
    if (symbol) symbol.textContent = shouldOpen ? "−" : "＋";
  }

  const thumb = event.target.closest(".gallery-thumb");
  if (thumb) {
    event.preventDefault();
    const productSection = thumb.closest("[data-product-section]");
    const mainImage = productSection?.querySelector("#MainProductImage");
    const galleryMain = productSection?.querySelector(".product-gallery__main");
    const zoomButton = galleryMain?.querySelector(".zoom-button");

    if (mainImage && thumb.dataset.image) {
      mainImage.removeAttribute("srcset");
      mainImage.removeAttribute("sizes");
      mainImage.src = thumb.dataset.image;
      mainImage.alt = thumb.querySelector("img")?.alt || mainImage.alt;
    }

    productSection?.querySelector(".gallery-thumb.is-active")?.classList.remove("is-active");
    thumb.classList.add("is-active");
    galleryMain?.classList.remove("is-zoomed");
    if (zoomButton) zoomButton.textContent = "＋";
  }

  const zoomButton = event.target.closest(".zoom-button");
  if (zoomButton) {
    const gallery = zoomButton.closest(".product-gallery__main");
    const isZoomed = gallery?.classList.toggle("is-zoomed");
    zoomButton.textContent = isZoomed ? "−" : "＋";
  }

  const quantityButton = event.target.closest("[data-quantity]");
  if (quantityButton) {
    const input = quantityButton.parentElement.querySelector('input[name="quantity"]');
    if (input) {
      const current = Number(input.value) || 1;
      input.value = quantityButton.dataset.quantity === "plus" ? current + 1 : Math.max(1, current - 1);
    }
  }

  const stickyAddButton = event.target.closest("[data-sticky-add-to-cart]");
  if (stickyAddButton) {
    event.preventDefault();
    const section = stickyAddButton.closest("[data-product-section]");
    const productButton = section?.querySelector(".add-to-cart");
    if (productButton && !productButton.disabled) productButton.click();
  }

  const cartActionButton = event.target.closest("[data-cart-action]");
  if (cartActionButton) {
    event.preventDefault();
    const form = cartActionButton.closest("[data-cart-form]");
    if (!form) return;

    cartActionButton.setAttribute("aria-busy", "true");
    submitCartForm(form, cartActionButton.dataset.cartAction);
  }

  const reviewSummaryLink = event.target.closest("[data-review-summary-link]");
  if (reviewSummaryLink) {
    const reviewWidget = document.querySelector("#judgeme_product_reviews");
    if (reviewWidget) {
      event.preventDefault();
      reviewWidget.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start",
      });
      window.history.replaceState({}, "", "#judgeme_product_reviews");
    }
  }

  const testimonialButton = event.target.closest("[data-testimonial-prev], [data-testimonial-next]");
  if (testimonialButton) rotateTestimonial(testimonialButton);
});

document.addEventListener("input", (event) => {
  if (!event.target.matches("[data-cart-quantity]")) return;
  const form = event.target.closest("[data-cart-form]");
  const status = form?.querySelector("[data-cart-update-status]");
  if (!form) return;

  window.clearTimeout(cartUpdateTimer);
  if (status) status.textContent = "Updating…";
  cartUpdateTimer = window.setTimeout(() => submitCartForm(form, "update"), 700);
});

document.addEventListener("change", (event) => {
  if (event.target.matches("[data-localization-select]")) {
    event.target.form?.submit();
  }
  if (event.target.matches("[data-sort-select]")) {
    event.target.form?.submit();
  }
});

const updateSasSelectedVariant = (section) => {
  if (!section) return;
  const variantData = section.querySelector("[data-product-json]");
  if (!variantData) return;
  const variants = JSON.parse(variantData.innerHTML || "[]");
  const optionGroups = [...section.querySelectorAll("[data-option-position]")]
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
  const options = optionGroups.map(
    (group) => group.querySelector(".is-selected")?.dataset.optionValue || ""
  );
  const variant = variants.find((item) =>
    item.options.length === options.length
    && item.options.every((option, index) => String(option) === options[index])
  );
  const form = section.querySelector("[data-product-form]");
  const button = form?.querySelector(".add-to-cart");
  const idInput = form?.querySelector("[data-variant-id]");

  if (!variant) {
    if (button) {
      button.disabled = true;
      const addLabel = button.querySelector("[data-add-label]");
      if (addLabel) addLabel.replaceChildren(document.createTextNode("Unavailable"));
    }
    return;
  }

  if (idInput) idInput.value = variant.id;
  const price = section.querySelector("[data-product-price]");
  const addPrice = section.querySelector("[data-add-price]");
  if (price) price.replaceChildren(document.createTextNode(money(variant.price)));
  if (addPrice) addPrice.replaceChildren(document.createTextNode(money(variant.price)));
  const stickyPrice = section.querySelector("[data-sticky-product-price]");
  if (stickyPrice) stickyPrice.replaceChildren(document.createTextNode(money(variant.price)));
  if (button) {
    button.disabled = !variant.available;
    const addLabel = button.querySelector("[data-add-label]");
    if (addLabel) {
      addLabel.replaceChildren(document.createTextNode(variant.available ? "Add to bag" : "Sold out"));
    }
  }

  const mediaId = variant.featured_media?.id;
  const imageUrl = variant.featured_media?.preview_image?.src || variant.featured_image?.src;
  const matchingThumb = mediaId
    ? section.querySelector(`[data-media-id="${mediaId}"]`)
    : null;
  const mainImage = section.querySelector("#MainProductImage");
  const galleryMain = section.querySelector(".product-gallery__main");

  if (mainImage && imageUrl) {
    mainImage.removeAttribute("srcset");
    mainImage.removeAttribute("sizes");
    mainImage.src = imageUrl;
    mainImage.alt = matchingThumb?.querySelector("img")?.alt || mainImage.alt;
  }
  const stickyImage = section.querySelector(".mobile-sticky-cart__image");
  if (stickyImage && imageUrl) stickyImage.src = imageUrl;
  section.querySelector(".gallery-thumb.is-active")?.classList.remove("is-active");
  matchingThumb?.classList.add("is-active");
  matchingThumb?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
  galleryMain?.classList.remove("is-zoomed");
  const zoomButton = galleryMain?.querySelector(".zoom-button");
  if (zoomButton) zoomButton.replaceChildren(document.createTextNode("＋"));

  const url = new URL(window.location.href);
  url.searchParams.set("variant", variant.id);
  window.history.replaceState({}, "", url);
  idInput?.dispatchEvent(new Event("change", { bubbles: true }));
};

document.querySelectorAll("[data-product-section]").forEach((section) => {
  const productButton = section.querySelector(".add-to-cart");
  const stickyButton = section.querySelector("[data-sticky-add-to-cart]");
  if (!productButton || !stickyButton) return;

  const syncStickyButton = () => {
    stickyButton.disabled = productButton.disabled;
    stickyButton.toggleAttribute("aria-busy", productButton.getAttribute("aria-busy") === "true");
    const productLabel = productButton.querySelector("[data-add-label]");
    const stickyLabel = stickyButton.querySelector("[data-sticky-add-label]");
    if (productLabel && stickyLabel) stickyLabel.textContent = productLabel.textContent.trim();
  };

  syncStickyButton();
  new MutationObserver(syncStickyButton).observe(productButton, {
    attributes: true,
    childList: true,
    subtree: true,
  });
});

document.querySelectorAll("[data-product-form]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submitButton = form.querySelector(".add-to-cart");
    if (!submitButton || submitButton.disabled) return;

    submitButton.setAttribute("aria-busy", "true");
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error("Unable to add item");

      await response.json();
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
      const cart = await cartResponse.json();
      document.querySelectorAll("[data-cart-count]").forEach((count) => {
        count.textContent = cart.item_count;
      });

      if (document.body.dataset.cartType === "page") {
        window.location.href = `${window.Shopify?.routes?.root || "/"}cart`;
        return;
      }

      const toast = document.querySelector(".cart-toast");
      toast?.classList.add("is-visible");
      window.setTimeout(() => toast?.classList.remove("is-visible"), 2200);
    } catch (error) {
      window.alert(error.message);
    } finally {
      submitButton.removeAttribute("aria-busy");
    }
  });
});

function rotateTestimonial(button) {
  const slider = button.closest("[data-testimonial-slider]");
  const testimonials = [...slider.querySelectorAll("[data-testimonial]")];
  let index = testimonials.findIndex((item) => !item.classList.contains("is-hidden"));
  index = button.hasAttribute("data-testimonial-next")
    ? (index + 1) % testimonials.length
    : (index - 1 + testimonials.length) % testimonials.length;
  testimonials.forEach((item, itemIndex) => item.classList.toggle("is-hidden", itemIndex !== index));
  const counter = slider.querySelector("[data-testimonial-index]");
  if (counter) counter.textContent = index + 1;
}

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  }
}

customElements.define("product-recommendations", ProductRecommendations);

if (document.body.classList.contains("reveal-animations")) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -10% 0px" }
  );
  document.querySelectorAll("main > .shopify-section").forEach((section) => observer.observe(section));
}

document.addEventListener("shopify:section:load", () => {
  document.documentElement.classList.remove("no-js");
  initializeSeamlessMarquees();
});
